import { ACC_LIB_DIARY_ITEM } from './acc-lib-diary.js'
import { ACC_LIB_LEDGER_ITEM } from './acc-lib-ledger.js'
import { ACC_LIB_BALANCE_ITEM } from './acc-lib-balance.js'

/** @type {import('../help-index.js').HelpScreen} */
export const ACC_LIB_HELP = {
  screenId: 'acc-lib',
  label: 'Libros',
  navPath: 'Contabilidad → Libros',
  keywords: [
    'libro diario', 'libro mayor', 'balance sumas y saldos', 'informe contable',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Informes contables: diario cronológico, mayor por cuenta y balance de sumas y saldos.',
  sidebarItems: [
    ACC_LIB_DIARY_ITEM,
    ACC_LIB_LEDGER_ITEM,
    ACC_LIB_BALANCE_ITEM,
  ],
}
